"use client";

import { usePathname } from 'next/navigation';
import GlobalCart from './GlobalCart';

export const ConditionalGlobalCart = () => {
  const pathname = usePathname();
  const shouldHideCart = pathname?.startsWith('/mobile-menu');

  return shouldHideCart ? null : <GlobalCart />;
};
